export function humanizeTag(tag) {
  if (!tag) return "Untitled";
  const cleaned = String(tag).replace(/^\//, "").trim();
  return cleaned
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function formatShortcutForApi(shortcut) {
  const cleaned = String(shortcut || "").trim();
  if (!cleaned) return "";
  const withoutSlash = cleaned.replace(/^\//, "").trim();
  return `/${withoutSlash}`;
}

export function formatShortcut(shortcutOrTag) {
  if (!shortcutOrTag) return "/";
  const cleaned = String(shortcutOrTag).replace(/^\//, "").trim();
  return `/ ${cleaned}`;
}

export function normalizeShortcut(shortcut) {
  return String(shortcut || "").replace(/^\//, "").trim();
}

export function parseCannedPrivate(item) {
  if (!item) return false;

  const { is_private: isPrivate, in_business: inBusiness } = item;

  if (isPrivate === true || isPrivate === 1 || isPrivate === "true") return true;
  if (isPrivate === false || isPrivate === 0 || isPrivate === "false") return false;

  if (typeof inBusiness === "boolean") return !inBusiness;
  if (inBusiness === 1 || inBusiness === "true") return false;
  if (inBusiness === 0 || inBusiness === "false") return true;

  return false;
}

export function extractCannedGroupIds(item) {
  if (!item) return [];

  const groups = item.groups || item.group_ids || item.groupIds || [];
  if (Array.isArray(groups) && groups.length) {
    return groups
      .map((entry) => {
        if (typeof entry === "object" && entry !== null) {
          return String(entry._id || entry.id || "");
        }
        return String(entry);
      })
      .filter(Boolean);
  }

  if (Array.isArray(item.groupDetails) && item.groupDetails.length) {
    return item.groupDetails
      .map((detail) => String(detail._id || detail.id || ""))
      .filter(Boolean);
  }

  return [];
}

export function extractCannedGroupId(item) {
  const ids = extractCannedGroupIds(item);
  return ids[0] || "";
}

export function buildCreateCannedPayload({
  title,
  content,
  shortcut,
  businessId,
  isPrivate,
  groupIds = [],
}) {
  const resolvedShortcut = shortcut || title;
  return {
    title: (title || humanizeTag(resolvedShortcut)).trim(),
    content,
    shortcut: formatShortcutForApi(resolvedShortcut),
    business_id: businessId,
    is_private: isPrivate,
    groups: groupIds,
  };
}

export function mapCannedItemToForm(item) {
  if (!item) {
    return {
      title: "",
      shortcut: "",
      content: "",
      groupIds: [],
      isPrivate: false,
    };
  }

  const isPrivate = parseCannedPrivate(item);
  const groupIds = extractCannedGroupIds(item);

  return {
    title: item.title || humanizeTag(item.shortcut || item?.tagDetails?.tag),
    shortcut: normalizeShortcut(item.shortcut || item?.tagDetails?.tag),
    content: item.content || "",
    groupIds,
    isPrivate,
  };
}

export function getGroupsLabel(item, groupMap) {
  if (item.is_private) return null;

  if (Array.isArray(item.groupDetails) && item.groupDetails.length) {
    return `Groups: ${item.groupDetails.map((group) => group.title).join(", ")}`;
  }

  const ids = item.groups || item.group_ids || item.groupIds || [];
  if (Array.isArray(ids) && ids.length) {
    const names = ids
      .map((id) => groupMap.get(String(id)))
      .filter(Boolean);
    if (names.length) return `Groups: ${names.join(", ")}`;
  }

  if (Array.isArray(item.groups) && item.groups.length && typeof item.groups[0] === "object") {
    return `Groups: ${item.groups.map((g) => g.title || g.name).join(", ")}`;
  }

  return "Groups: All teams";
}

export function getErrorMessage(payload) {
  if (!payload) return "Something went wrong";
  if (typeof payload === "string") return payload;
  return (
    payload.message ||
    payload.error ||
    (Array.isArray(payload.errors) && payload.errors[0]?.message) ||
    "Something went wrong"
  );
}
